/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAdvancedNotesViewProps } from './advanced-notes';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IAdvancedNotesViewProps) => {
    const { staticDisplay, advancedNotesModuleProps } = props;
    return (
        <Module {...advancedNotesModuleProps}>
            <Node {...staticDisplay} />
        </Module>
    );
};
